import { ITranslations } from 'types/common';
import { ScriptBasicFormTransFields } from './types';
import en from 'translations/en/scriptBasicForm.json';
import pl from 'translations/pl/scriptBasicForm.json';
import sl from 'translations/sl/scriptBasicForm.json';

export const scriptBasicFormTranslations: ITranslations<ScriptBasicFormTransFields> = {
  name: 'scriptBasicForm',
  en,
  pl,
  sl,
};
